module.exports = __webpack_public_path__ + "assets/img/seal-eceb8e39.png";